import * as React from 'react';

const SvgSmsMini = (props) => (
  <svg
    width={32}
    height={32}
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M22.667 4.667H9.334c-4 0-6.667 2-6.667 6.666v9.334c0 4.666 2.667 6.666 6.667 6.666h13.333c4 0 6.667-2 6.667-6.666v-9.334c0-4.666-2.667-6.666-6.667-6.666Zm.627 8.12L19.12 16.12c-.88.707-2 1.053-3.12 1.053s-2.253-.346-3.12-1.053l-4.173-3.333a1.026 1.026 0 0 1-.16-1.414.997.997 0 0 1 1.4-.16l4.173 3.334c1.014.813 2.734.813 3.747 0l4.173-3.334a.984.984 0 0 1 1.4.16c.347.427.28 1.067-.146 1.414Z'
      fill='#E00034'
    />
  </svg>
);

export default SvgSmsMini;
